<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('End of day')"
          :text="$t('eod-info-text')"
          :btnText="$t('Create EOD')"
          @action="createEOD" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table" v-if="get_end_of_day_list.items.length > 0">
          <li
            v-for="(item, index) in get_end_of_day_list.items" :key="`item-${index}`"
            @click="goToPage(item.batch_number)"
            class="list-table-item"
          >
            <div class="table-cell small">
              <div class="status-logo-box float-left">
                <Icon
                  v-if="item.batch_agents_array.length > 1"
                  :circle=true
                  name="fileCopies"
                  size="24" />
                <LogosSVG
                  v-if="item.batch_agents_array.length == 1"
                  :name="item.batch_agents_array[0]"
                  size="45" />
              </div>
            </div>
            <div class="table-cell">
              <p>
                <span class="main-info">
                  {{ `${item.colli_amount} ${$t('colli').toLowerCase()}` }}
                  {{ `(${parseFloat(item.batch_weight).toFixed(2)} kg.)` }}
                </span>
                <span class="additional-info">
                  {{ formatDate(item.batch_date) }}
                </span>
              </p>
            </div>
          </li>
        </ul>
        <div v-if="get_end_of_day_list.items.length > 0" v-observe-visibility="visibilityChanged"></div>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      minHeight="450px"
      :confirmText="$t('generate')"
      @cancel="togglePopup"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('Create EOD') }}</h2>
      </template>
      <div>
        <div class="col-xs-12">
          <InputSelect
            class="m-b-20"
            :multiSelect=true
            :label="$t('accounts')"
            @change="selectSubaccount"
            :preselected="subaccounts"
            :options="get_allowed_subaccounts_select_options"
            :rules="{required: true}" />
        </div>
        <div class="col-xs-6 m-b-20">
          <Calendar
            :disable-weekend="false"
            :noMinDate="true"
            :label="$t('from_date')"
            v-model="fromDate"
            :date="fromDate"
            :rules="{required: true}" />
        </div>
        <div class="col-xs-6 m-b-20">
          <Calendar
            :disable-weekend="false"
            :label="$t('to_date')"
            v-model="toDate"
            :date="toDate"
            :min-date-prop="fromDate"
            :rules="{required: true}" />
        </div>
        <div class="col-xs-12">
          <InputSelect
            class="m-b-20"
            :multiSelect=true
            :label="$t('shipping_agent_name')"
            :preselected="carriers"
            @change="selectAgents"
            :options="get_company_available_shipping_agents_select"
          />
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import AddressPicker from "@/components/global/addressPicker/index.vue";
import PhoneSelect from "@/components/elements/inputs/phone.vue";
import CountryFlag from 'vue-country-flag';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import countryList from '@/data/country.js';
import LogosSVG from "@/assets/images/logosSVG";
import date from '@/mixins/date'
import Calendar from '@/components/elements/inputs/calendar.vue';

import InfoTextBox from '@/components/global/infoTextBox';

export default {
  name: 'EndOfDay',
  components: {
    Btn,
    AddressPicker,
    PhoneSelect,
    Popup,
    InputText,
    InputSelect,
    Toggle,
    InfoTextBox,
    LogosSVG,
    Calendar,
  },
  mixins: [date],
  data() {
    return {
      page: 1,
      openPopup: false,
      isEdit: false,
      carriers: [],
      fromDate: new Date(),
      toDate: new Date(),
      subaccounts: []
    };
  },
  computed: {
    ...mapGetters([
      'get_end_of_day_list',
      'get_company_available_shipping_agents_select',
      'get_allowed_subaccounts_select_options'
    ]),
  },
  created() {
    this.getShipments();
    this.setInitialSelectedSubaccounts()
  },
  methods: {
    selectSubaccount(val) {
      if (val.length > 0) {
        this.subaccounts = val;
      }
    },
    setInitialSelectedSubaccounts() {
      this.subaccounts = this.get_allowed_subaccounts_select_options.map((obj) => {
        return obj.value;
      });
    },
    createEOD() {
      this.isEdit = false;
      this.togglePopup();
      this.$store.dispatch('GET_COMPANY_AVAILABLE_SHIPPING_AGENTS').then((res) => {
        this.carriers = res.map((agent) => {
          return String(agent.id)
        });
      });
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.fromDate = '';
      this.toDate = '';
    },
    selectAgents(val) {
      this.carriers = val;
    },
    submitForm() {
      this.$store.dispatch('SET_EOD_SHIPMENTS', {
        fromDate: this.fromDate,
        toDate: this.toDate,
        carriers:  JSON.stringify(this.carriers),
        subaccounts: JSON.stringify(this.subaccounts)
      }).then((res) => {
        this.togglePopup();
        this.$store.dispatch('GET_SHIPMENTS_EOD', this.page);
      });
    },
    getShipments(){
      this.$store.dispatch('GET_SHIPMENTS_EOD', this.page);
    },
    goToPage(pageID) {
      this.$router.push(`end-of-day/${pageID}`);
    },
    visibilityChanged() {
      if(this.get_end_of_day_list.count > this.get_end_of_day_list.length){
        this.page++;
        this.getShipments();
      }
    },
  },
};
</script>
